<template>
  <div class="export-item" @click.prevent="itemSelected = !itemSelected">
    <checkbox lightLabel :label="''" :name="item.id" :value="item.id" v-model="itemSelected" />
    <p>{{ item.contentID }}</p>
    <p>{{ item.name }}</p>
  </div>
</template>
<script>
import Checkbox from "@/components/Checkbox";
export default {
  data() {
    return {
      itemSelected: this.initiallySelected
    };
  },
  props: {
    item: Object,
    value: Array,
    inputValue: String,
    selectAll: Boolean,
    deselectAll: Boolean,
    initiallySelected: Boolean
  },
  components: {
    Checkbox
  },
  watch: {
    itemSelected: function() {
      this.$emit("isSelected", this.item.id);
    },
    selectAll: function() {
      if (this.selectAll) return (this.itemSelected = true);
    },
    deselectAll: function() {
      if (this.deselectAll) return (this.itemSelected = false);
    }
  }
};
</script>

<style lang="less">
.export-item {
  padding: 12px 15px;
  cursor: pointer;
  display: grid;
  grid-template-columns: 200px 1fr 1fr;
  &:hover {
    background-color: rgba(188, 193, 195, 0.2);
  }
  p {
    margin: 0;
  }
}
</style>